import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import "./WorkDetail.css";

export default function WorkShowcase() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          Canine Crown
        </h1>

        <p className="project-description">
          Brand identity for a sustainable materials
          company producing textiles with
          aquaculture-based technologies.
        </p>

        <div className="project-tags">
          <span className="info-tag">
            Brand Strategy

          </span>
          <span className="info-tag">

            Visual Identity
          </span>
          <span className="info-tag">Packaging System</span>
          <span className="info-tag">
            Digital Experience
          </span>
          <span className="info-tag">
            Website Design
          </span>
          <span className="info-tag">
            Social Campaigns
          </span>
          <span className="info-tag">
            Creative Direction
          </span>
        </div>


      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/CanineCrown/logosketch.webp" alt="Canine Crown Hero" />
      </div>
     
      <section className="project-split-images-section">
        <img src="https://ascentbw.com/Images/CanineCrown/Half.webp" alt="Kelsun Lab Worker" />
        <img src="https://ascentbw.com/Images/CanineCrown/Half0.webp" alt="Keel Labs Materials" />
      </section>
       <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We designed a distinctive brand identity for Canine Crown, creating a memorable logo that reflects trust, care, and premium pet nutrition. The visual identity combines a regal crown with a canine-inspired mark, establishing a strong and recognizable presence across digital and physical touchpoints."
        </div>
      </section>
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/CanineCrown/Hero1.webp" alt="Canine Crown Hero" />
      </div>
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/CanineCrown/Hero2.webp" alt="Canine Crown Hero" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We designed a modern and user-friendly website that showcases Canine Crown's product range while delivering a seamless browsing and shopping experience. The design focuses on usability, accessibility, and brand consistency across every touchpoint."
        </div>
      </section>

      <section className="project-full-image-section">
        <img src="https://ascentbw.com/Images/CanineCrown/Full1.webp" alt="Keel Labs Visual Identity" />
      </section>

      <section className="project-split-images-section">
        <img src="https://ascentbw.com/Images/CanineCrown/Half1.webp" alt="Kelsun Lab Worker" />
        <img src="https://ascentbw.com/Images/CanineCrown/Half2.webp" alt="Keel Labs Materials" />
      </section>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "From promotional campaigns to seasonal creatives, we developed impactful social media content that strengthens brand awareness and builds meaningful engagement with pet lovers."
        </div>
      </section>

      <section className="project-full-image-section">
        <img src="https://ascentbw.com/Images/CanineCrown/Full3.webp" alt="Keel Labs Yarn" />
      </section>

      <section className="project-split-images-section">
        <img src="https://ascentbw.com/Images/CanineCrown/Half3.webp" alt="Kelsun Lab Worker" />
        <img src="https://ascentbw.com/Images/CanineCrown/Half4.webp" alt="Keel Labs Materials" />
      </section>

      <section className="project-full-image-section">
        <img src="https://ascentbw.com/Images/CanineCrown/Full4.webp" alt="Keel Labs Yarn" />
      </section>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Our packaging design approach focused on creating a premium visual identity while clearly communicating product benefits. The result is a cohesive packaging system that enhances shelf appeal and strengthens customer trust."
        </div>
      </section>
      <section className="project-full-image-section">
        <img src="https://ascentbw.com/Images/CanineCrown/Full2.webp" alt="Keel Labs Yarn" />
      </section>

    {/*   <section className="project-dark-section">
        <div className="dark-section-header">
          <h2>Our Future is the Ultimate Project</h2>
          <p>
            Deploying information design, branding, installations, and digital applications, Pentagram has partnered with groundbreaking environmental organizations around the world — public, private, and nonprofit — to confront the challenge of climate change. Addressing complex data and scientific concepts requires not just precision and rigor, but empathy and humanity. And in the face of urgency that can sometimes seem overwhelming, we must never forget the power of beauty, storytelling and, above all, optimism.
          </p>
        </div>

        <div className="dark-section-grid">
          <div className="dark-card">
            <img src="https://images.unsplash.com/photo-1618044733300-9472054094ee?auto=format&fit=crop&q=80&w=800" alt="Climate Tech Map" />
            <div className="dark-card-content">
              <h3>Climate Tech Map</h3>
              <p>A website that gives shape to the growing universe of climate technologies — both...</p>
            </div>
          </div>
          <div className="dark-card">
            <img src="https://images.unsplash.com/photo-1518623489648-a173ef7824f3?auto=format&fit=crop&q=80&w=800" alt="MethaneSAT" />
            <div className="dark-card-content">
              <h3>MethaneSAT</h3>
              <p>Visual identity, data visualization, and website for a new satellite that will orbit the Earth's...</p>
            </div>
          </div>
          <div className="dark-card">
            <img src="https://images.unsplash.com/photo-1473448912268-2022ce9509d8?auto=format&fit=crop&q=80&w=800" alt="The Great Green Wall Frontline" />
            <div className="dark-card-content">
              <h3>The Great Green Wall Frontline</h3>
              <p>Identity for a climate initiative in Africa which sets out to be the largest living structure on...</p>
            </div>
          </div>
          <div className="dark-card">
            <img src="https://images.unsplash.com/photo-1611284446314-60a58ac0deb9?auto=format&fit=crop&q=80&w=800" alt="Plastic Air" />
            <div className="dark-card-content">
              <h3>Plastic Air</h3>
              <p>An interactive experience for Google Arts & Culture explores the environmental impact...</p>
            </div>
          </div>
        </div>
      </section> */}
      <Footer />
    </div>
  );
}